export default __webpack_public_path__ + "static/media/check_list.def8b423.svg";